// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"styles_headingWrapper__23YWx"};